import { UseQueryOptions } from '@tanstack/react-query';

import { CuredApiPaths } from 'models/enums';
import { ContactColumn } from 'models/types';

import useQuery from '../useQuery';

const useContactColumns = (reactQueryOptions?: UseQueryOptions<ContactColumn[], Error>) =>
    useQuery('contactColumns', CuredApiPaths.CONTACT_COLUMNS, reactQueryOptions);

export default useContactColumns;
